import BoxLayoutContent from "@/shared/components/layout/boxLauotContent";
import { ContentTitle } from "@/shared/components/layout/titleContentLayout";
import { SelectChangeEvent } from "@mui/material";
import  { useState } from "react";
import Content from "./content";
import { GiftIcon } from "@/shared/components/common/icons";
/**
 * StorePoint
 *
 * مدیریت و نمایش امتیازات فروشگاهی مشتری با امکان انتخاب موجودی کیف پول.
 *
 * @remarks
 * - از useState برای مدیریت مقدار انتخابی در منوی بالای صفحه استفاده می‌کند.
 * - `ContentTitle` برای نمایش عنوان صفحه و انتخاب موجودی و فیلترهای مرتبط استفاده می‌شود.
 * - `Content` جدول امتیازات فروشگاهی را نمایش می‌دهد.
 * - `BoxLayoutContent` ساختار صفحه را فراهم می‌کند.
 *
 * @returns JSX.Element
 * کامپوننتی که جدول امتیازات فروشگاهی مشتری را به همراه منوی انتخاب موجودی نمایش می‌دهد.
 */

const StorePoint = () => {
  // const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");
  const menuOptions = [
    { value: "option1", label: "موجودی نقدی : 5,000,000 ریال" },
    { value: "option2", label: "گزینه دوم" },
    { value: "option3", label: "گزینه سوم" },
    { value: "option4", label: "گزینه چهارم" },
    { value: "option5", label: "گزینه پنجم" },
  ];

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };
  return (
    <>
      <ContentTitle handleChange={handleChange} icon={<GiftIcon />} labelInput="انتخاب گزینه" value={value} setValue={setValue} title="امتیازات فروشگاهی" options={menuOptions}/>
      <BoxLayoutContent>
        <Content />
      </BoxLayoutContent>
    </>
  );
};

export default StorePoint;
